var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconEmail = function SvgIconEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 50,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 67,
    height: 48,
    rx: 2,
    stroke: "#8733FE",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.1962 30.2787L32.5443 31.037L33.1962 30.2787ZM35.8038 30.2787L36.4557 31.037L35.8038 30.2787ZM0.348091 3.35791L32.5443 31.037L33.8481 29.5204L1.65191 1.84131L0.348091 3.35791ZM36.4557 31.037L68.6519 3.35791L67.3481 1.84131L35.1519 29.5204L36.4557 31.037ZM32.5443 31.037C33.6689 32.0038 35.3311 32.0038 36.4557 31.037L35.1519 29.5204C34.777 29.8427 34.223 29.8427 33.8481 29.5204L32.5443 31.037Z",
    fill: "#8733FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 48.5L26 24.5",
    stroke: "#8733FE",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5 24.5L67.5 48.5",
    stroke: "#8733FE",
    strokeWidth: 2
  })));
};
export default SvgIconEmail;